import { render, staticRenderFns } from "./ossChart.vue?vue&type=template&id=296aa31f"
import script from "./ossChart.vue?vue&type=script&lang=js"
export * from "./ossChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports